var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmiley(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 31.5C25.4558 31.5 31.5 25.4558 31.5 18C31.5 10.5442 25.4558 4.5 18 4.5C10.5442 4.5 4.5 10.5442 4.5 18C4.5 25.4558 10.5442 31.5 18 31.5Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8472 21.3745C23.2541 22.4003 22.4017 23.2519 21.3754 23.8441C20.3491 24.4362 19.1851 24.7479 18.0003 24.7479C16.8154 24.7479 15.6514 24.4362 14.6251 23.8441C13.5988 23.252 12.7464 22.4003 12.1533 21.3746",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9375 16.3125C13.5588 16.3125 14.0625 15.8088 14.0625 15.1875C14.0625 14.5662 13.5588 14.0625 12.9375 14.0625C12.3162 14.0625 11.8125 14.5662 11.8125 15.1875C11.8125 15.8088 12.3162 16.3125 12.9375 16.3125Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0625 16.3125C23.6838 16.3125 24.1875 15.8088 24.1875 15.1875C24.1875 14.5662 23.6838 14.0625 23.0625 14.0625C22.4412 14.0625 21.9375 14.5662 21.9375 15.1875C21.9375 15.8088 22.4412 16.3125 23.0625 16.3125Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmiley);
export default __webpack_public_path__ + "static/media/smiley.6a644b6687ed5fced35039a59e0d9c84.svg";
export { ForwardRef as ReactComponent };